/* TODO: t() */
import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';
import Text from './Text';
import Icon from './Icon';

type Props = {
  text: string;
  oneLine?: boolean;
  isShrinking?: boolean;
  width?: number;
};

type State = {
  isTextVisible: boolean;
};

class Infotip extends Component<Props, State> {
  state: State = {
    isTextVisible: false,
  };

  render() {
    let { text, width = 250, isShrinking, oneLine } = this.props;
    let { isTextVisible } = this.state;
    return (
      <View
        style={styles.iconContainer}
        onMouseEnter={this._onInfoTextShow}
        onMouseLeave={this._onInfoTextHide}
      >
        <Icon name="info" size="S" />
        {isTextVisible ? (
          <View
            style={[styles.infotipContainer, !isShrinking && { width: width }]}
          >
            <View style={styles.triangle} />
            {oneLine ? (
              <Text numberOfLines={1} style={styles.textBox}>
                {text}
              </Text>
            ) : (
              <Text style={styles.textBox}>{text}</Text>
            )}
          </View>
        ) : null}
      </View>
    );
  }

  _onInfoTextShow = () => {
    this.setState({ isTextVisible: true });
  };

  _onInfoTextHide = () => {
    this.setState({ isTextVisible: false });
  };
}

export default Infotip;

const styles = StyleSheet.create({
  iconContainer: {
    marginLeft: 4,
  },
  infotipContainer: {
    top: 10,
    left: 15,
    paddingLeft: 5,
    position: 'absolute',
  },
  triangle: {
    position: 'absolute',
    left: -5,
    width: 0,
    height: 0,
    borderColor: 'transparent',
    borderLeftWidth: 4,
    borderTopWidth: 0,
    borderBottomWidth: 10,
    borderRightWidth: 10,
    borderRightColor: '#CCC',
  },
  textBox: {
    backgroundColor: '#FFF',
    color: 'rgba(0,0,0,0.9)',
    fontSize: 12,
    // The font-weight is only needed because we're sometimes rendering inside
    // of a <label> which has some default styling of bold text. This won't be
    // an issue after we remove the stylesheets completely.
    fontWeight: 'normal',
    boxShadow: '0 5px 10px rgba(0, 0, 0, 0.2)',
    borderWidth: 1,
    borderColor: '#CCC',
    borderRadius: 3,
    padding: 6,
    zIndex: 1,
  },
});
